import React from "react";
import Image from "next/image";

const PlayDownloadButtons: React.FC = () => {
  return (
    <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4">
      <a
        href="https://apps.apple.com/us/app/travela/id1562887010"
        target="_blank"
        title="Travela on App Store"
        rel="noopener noreferrer"
      >
        <Image
          src="/images/button-app.svg"
          alt="Download on App Store"
          width={184}
          height={60}
          quality={100}
          unoptimized
        />
      </a>
      <a
        href="https://play.google.com/store/apps/details?id=com.travela.xyz"
        target="_blank"
        title="Travela on Google Play"
        rel="noopener noreferrer"
      >
        <Image
          src="/images/button-play.svg"
          alt="Get it on Google Play"
          width={184}
          height={60}
          quality={100}
          unoptimized
        />
      </a>
    </div>
  );
};

export default PlayDownloadButtons;
